import { Injectable, Injector } from '@angular/core';
import { AlarmsActiveDto } from '@common-modules/dependencies/alarms/alarms-active.dto';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';

const endpointUrl = '/api/alarm';
const oDataEndPoint = 'activation';
@InjectableByKey({ key: 'AlarmActivationsService' })
@Injectable({ providedIn: 'root' })
export class AlarmActivationsService extends GridODataService<AlarmsActiveDto> {
  constructor(injector: Injector) {
    super(injector, `${endpointUrl}/${oDataEndPoint}`);
  }

  protected mapResponse(
    response: PagedResultDto<AlarmsActiveDto>
  ): PagedResultDto<AlarmsActiveDto> {
    return response;
  }
}
